import { buildCssClassName, getTransitionTwClasses } from "@/3514/utils"

import { ETextAreaBorderWidth, ETextAreaScrollbarVariant, ETextAreaVariant } from "./textarea.types"

const _baseClasses: string = buildCssClassName(
    ["w-full", "px-[15px]", "py-[10px]", "break-keep", "placeholder:text-pretty", "text-pretty"],
    getTransitionTwClasses("all", 150)
)

const borderWidthMap: { [R in ETextAreaBorderWidth]: string } = {
    [ETextAreaBorderWidth.Tiny]: "border-[1px]",
    [ETextAreaBorderWidth.Medium]: "border-[2px]"
}

const variantClassesMap: {
    [V in ETextAreaVariant]: () => string
} = {
    [ETextAreaVariant.Default]: (): string =>
        buildCssClassName(_baseClasses, [
            "bg-white",
            "border-blue-400",
            "hover:border-blue-300",
            "focus:border-blue-300",
            "active:border-blue-300"
        ]),
    [ETextAreaVariant.LightGray]: (): string =>
        buildCssClassName(_baseClasses, [
            "border-gray-400",
            "hover:border-gray-300",
            "focus:border-gray-300",
            "active:border-gray-300"
        ]),
    [ETextAreaVariant.LightBlue]: (): string =>
        buildCssClassName(_baseClasses, [
            "caret-gray-200",
            "selection:bg-blue-400",
            "bg-blue-600",
            "border-blue-300",
            "hover:bg-white",
            "active:bg-white",
            "focus:bg-white",
            "focus:pb-[20px]"
        ]),
    [ETextAreaVariant.Error]: (): string =>
        buildCssClassName(_baseClasses, [
            "bg-white",
            "[border-color:transparent]",
            "hover:border-red-100",
            "focus:border-red-100",
            "active:border-red-100"
        ]),
    [ETextAreaVariant.Transparent]: (): string =>
        buildCssClassName(_baseClasses, [
            "!outline-[0px]",
            "!outline-transparent",
            "[border-color:transparent]",
            "hover:border-transparent",
            "focus:border-transparent",
            "active:border-transparent"
        ])
}

const scrollbarsClassesMap: { [V in ETextAreaScrollbarVariant]: (textareaColorVariant: ETextAreaVariant) => string } = {
    [ETextAreaScrollbarVariant.Transparent]: (_variant: ETextAreaVariant): string => "no-scrollbar",
    [ETextAreaScrollbarVariant.Thin]: (variant: ETextAreaVariant): string =>
        variant === ETextAreaVariant.LightGray ? "scrollbar-thin-gray" : "scrollbar-thin-blue"
}

const DEFAULT_MIN_LINES: number = 2

const DEFAULT_MAX_LINES: number = 8

const DEFAULT_BORDER_RADIUS: { tl?: number; tr?: number; br?: number; bl?: number } = {
    tl: 10,
    tr: 10,
    br: 10,
    bl: 10
}

const classes = { container: "flex flex-col gap-y-[5px] w-full", label: "hidden", error: "px-[10px]" }

const config = {
    variantClassesMap,
    borderWidthMap,
    scrollbarsClassesMap,
    DEFAULT_MIN_LINES,
    DEFAULT_MAX_LINES,
    DEFAULT_BORDER_RADIUS,
    classes
}

export { config as textareaConfig }
